export const GRAPH_SENSORS_LIMIT = 20;
